












































































































































































import {
  checklistPostReq
} from "@/services/checklist.service";
import { transferFailure } from "@/services/checklist_settings";


export default  {
  props: ['cl_item'], 
  data() {
    return {
      create_progress: false,
      checklist_dialog: {},
      create_error: false, 
      transfer_error: "",
      transfer_warning: "",
      // Läuft das Schreiben? Das X bleibt dann gesperrt: das Ergebnis erscheint nur in
      // diesem Dialog. Beim Lesen bleibt es frei, sonst käme man aus einer hängenden
      // Anfrage nicht heraus.
      transfer_saving: false,
      transfer_stale: false,
      database_entry: "inspect-common", 
      cl_entry: {}, 
      view_mode: 'database',
      versions: [
        'Minor Version',
        'Major Version'
      ],
      databases: [
        //'checklisten-dev',
        //'inspect-common-debug',
        'inspect-common'
      ],
    }
  },
  watch: {

  },
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
  },
  mounted() {
   this.chooseDatabase()
  },
  destroyed() {
  },
  methods: {
    closeDialog: function () {
      if (this.transfer_saving) {
        return
      }
      this.$emit("dialogClosed", true);
    },
    chooseDatabase: function () {


      if (this.database_entry.length > 2) {
        this.create_progress = true
        this.create_error = false
        this.transfer_error = ""
        checklistPostReq('couchdb-getchecklist', { uid: this.cl_item.uid, database: this.database_entry }) 
          .then(resp => {
            this.create_progress = false
            this.cl_entry = resp.item
            this.view_mode = 'form'
          })
          .catch(e => {
            this.create_progress = false
            const failure = transferFailure(e)
            this.transfer_error = (failure && failure.message) || this.$t('TRANSFER_INSPECT.LOAD_FAILED')
            if (!failure) {
              this.$store.dispatch("api_error", e);
            }
        });  
      }
      else {
        this.create_error = true
      }
    },
    // Nach einem Fehlschlag zeigt das Formular sonst den Stand vom Öffnen. Die Eingaben
    // bleiben. Ein Fehlschlag hier geht nicht an `api_error`: den des Schreibens hat der
    // Nutzer schon gesehen, der Hinweis im Dialog nennt den Weg.
    reloadEntry: function () {
      const version = this.cl_entry.version
      const comment = this.cl_entry.comment
      this.create_progress = true
      checklistPostReq('couchdb-getchecklist', { uid: this.cl_item.uid, database: this.database_entry })
        .then(resp => {
          this.create_progress = false
          this.cl_entry = Object.assign({}, resp.item, { version: version, comment: comment })
        })
        .catch(() => {
          this.create_progress = false
          this.transfer_stale = true
        })
    },
    save: function () {
      if (this.create_progress || this.view_mode != 'form') {
        return
      }
      this.create_error = false
      this.transfer_error = ""
      this.transfer_stale = false
      if (!this.cl_entry.version ) {
        this.create_error = true
      } else {
         this.create_progress = true
         this.transfer_saving = true
      
          // `rev` bleibt, solange ein Backend laufen kann, das sie noch auswertet: dort
          // ginge ein vorhandenes Dokument ohne `_rev` nicht durch, und der Fehler bliebe
          // still. Ein Backend mit dem Abgleich der Sichtbarkeit ignoriert sie.
          checklistPostReq('couchdb-transferchecklist', { database: this.cl_entry.database, 
                                                          version: this.cl_entry.version, 
                                                          comment: this.cl_entry.comment, 
                                                          uid: this.cl_item.uid, 
                                                          rev: this.cl_entry._rev }) 
            .then(resp => {
              console.log(resp)
              this.transfer_saving = false
              this.$emit("dialogClosed", true);
            })
            .catch(e => {
              this.create_progress = false
              this.transfer_saving = false
              const failure = transferFailure(e)
              if (failure && failure.written) {
                this.transfer_warning = failure.message || this.$t('TRANSFER_INSPECT.HISTORY_WARNING')
                this.view_mode = 'transferred'
                return
              }
              this.transfer_error = (failure && failure.message) || this.$t('TRANSFER_INSPECT.SAVE_FAILED')
              if (!failure) {
                this.$store.dispatch("api_error", e);
              }
              this.reloadEntry()
          }); 

      }
    }
   
  }
}

